import React, { useState, useEffect, useRef } from 'react'
import { Col, Button, Card } from 'antd'
import { paginationInit, formatMessage } from '@/utils/common'
import { messageModal } from '@/utils/modalUtils'
import { getRFIDSkuList, refreshRFID, getRFIDUpdateTime } from '@/services/sku/sku'
import { SyncOutlined, SearchOutlined } from '@ant-design/icons'
import AntdTable from '@/components/table/AntdTable'
import SearchBar from '@/components/searchbar/SearchBar'
import { useSelector } from 'react-redux'
import { hasPermission } from '@/annotations/nike-react'
import moment from 'moment'
const menu_nfc_nfcSkuUpdate_rfidSku = 'menu_nfc_nfcSkuUpdate_rfidSku'
const RFIDSKUPage = () => {
  const commonStore = useSelector(state => state.commonStore)
  const tableColumns = [
    {
      title: formatMessage(commonStore, 'languageObj.commonLocale.productCode'),
      dataIndex: 'productCode'
    },
    {
      title: formatMessage(commonStore, 'languageObj.commonLocale.productName'),
      dataIndex: 'productName'
    }
  ]

  let formRef = useRef(null)
  let searchListInit = [
    {
      type: 'input',
      label: 'languageObj.commonLocale.productCode',
      key: 'productCode',
      initialValues: '',
      spans: {
        xl: 7,
        xxl: 7
      }
    }
  ]

  const [tableList, setTableList] = useState([])
  const [updateTime, setUpdateTime] = useState(0)
  const [queryFlag, setQueryFlag] = useState(false)
  const [pagination, setPagination] = useState(paginationInit)

  useEffect(() => {
    lastUpdateTime()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const lastUpdateTime = () => {
    getRFIDUpdateTime({}).then(res => {
      if (res.errorCode === '200') {
        if (res?.resultData > 0) {
          setUpdateTime(res.resultData)
        }
      }
    })
  }

  useEffect(() => {
    searchDataFun()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [queryFlag])
  const searchDataBtn = () => {
    const pg = {
      ...pagination,
      currentPage: 1
    }
    setPagination(pg)
    setQueryFlag(!queryFlag)
  }
  const searchClearDataBtn = () => {
    formRef && formRef.current.clearForm()
    const pg = {
      ...pagination,
      currentPage: 1
    }
    setPagination(pg)
    setQueryFlag(!queryFlag)
  }
  const handleTableChange = pagina => {
    const params = {
      ...pagination,
      currentPage: pagina.current,
      pageSize: pagina.pageSize
    }
    setPagination({ ...params })
    setQueryFlag(!queryFlag)
  }
  const searchDataFun = () => {
    let info = {}
    info = (formRef.current && formRef.current.getValue()) || {}
    const params = {
      ...info,
      size: pagination.pageSize,
      pageNo: pagination.currentPage
    }
    getRFIDSkuList(params).then(res => {
      const dt = res.resultData
      setTableList(dt.records)
      const pg = {
        ...pagination,
        total: dt.total
      }
      setPagination(pg)
    })
  }

  const refreshDataBtn = () => {
    refreshRFID({}).then(res => {
      if (res.errorCode === '200') {
        messageModal('success', {
          content: formatMessage(commonStore, 'languageObj.commonLocale.success')
        })
        setQueryFlag(!queryFlag)
        lastUpdateTime()
      }
    })
  }
  const getUpdateHtml = () => {
    return (
      <div style={{ paddingLeft: 16, display: 'flex', justifyContent: 'flex-start' }}>
        <div></div>
        {updateTime !== 0 ? (
          <div style={{ marginRight: '20px', display: 'flex', alignItems: 'center' }}>
            {formatMessage(commonStore, 'languageObj.nspskuLocale.updatedTime')}
            {moment(new Date(updateTime)).format('YYYY-MM-DD HH:mm:ss')}
          </div>
        ) : null}
      </div>
    )
  }
  return (
    <Card bordered={false} bodyStyle={{ padding: 4 }}>
      <div className="search-bar">
        <SearchBar ref={formRef} searchList={searchListInit}>
          <Col
            xs={24}
            sm={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="right_search"
            style={{ justifyContent: 'flex-end' }}
          >
            <Button icon={<SearchOutlined />} type="primary" onClick={searchDataBtn}>
              {formatMessage(commonStore, 'languageObj.commonLocale.search')}
            </Button>
            <Button onClick={searchClearDataBtn}>{formatMessage(commonStore, 'languageObj.commonLocale.clear')}</Button>
            {hasPermission(menu_nfc_nfcSkuUpdate_rfidSku) && (
              <Button type="primary" onClick={refreshDataBtn}>
                <SyncOutlined />
                {formatMessage(commonStore, 'languageObj.nspskuLocale.refreshRFID')}
              </Button>
            )}
          </Col>
        </SearchBar>
      </div>
      {getUpdateHtml()}
      <div className="content-container">
        <AntdTable dataSource={tableList} columns={tableColumns} pagination={pagination} onChange={handleTableChange} />
      </div>
    </Card>
  )
}
export default RFIDSKUPage
